import React from 'react';
import { Box, Props } from '../Box';
import { shimmer } from './styles';

export const ShimmerBox: React.FC<Props> = props => {
  const { width = '100%', height = 18 } = props;
  return <Box css={shimmer} width={width} height={height} {...props}></Box>;
};
